import styled from 'styled-components';
import { WIDGET_PREVIEW_TRAY_GRADIENT } from '../../../../constants/dashboardBuilderConstants';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1.5px solid
    ${(props) =>
      props.$selected ? props.theme.colors.celticBlue : props.theme.colors.dividerGray};
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  background: ${(props) => props.theme.colors.white};

  &:hover {
    border-color: ${(props) =>
      props.$selected ? props.theme.colors.celticBlue : props.theme.colors.clearGray};
  }
`;

export const PreviewExpandButton = styled.button`
  position: absolute;
  top: ${(props) => props.theme.spacing.sm};
  right: ${(props) => props.theme.spacing.sm};
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid ${(props) => props.theme.colors.davysGrey};
  background: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.davysGrey};
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.12s ease, background 0.12s ease;

  &:hover {
    background: ${(props) => props.theme.colors.hoverGrey};
  }

  &:focus-visible {
    opacity: 1;
    pointer-events: auto;
    outline: 2px solid ${(props) => props.theme.colors.celticBlue};
    outline-offset: 1px;
  }
`;

export const PreviewArea = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: center;
  flex-shrink: 0;
  height: 112px;
  margin: ${(props) => props.theme.spacing.md};
  margin-bottom: ${(props) => props.theme.spacing.sm};
  padding: ${(props) => props.theme.spacing.base};
  box-sizing: border-box;
  overflow: hidden;
  border-radius: ${(props) => props.theme.borderRadius.base};
  background: linear-gradient(
    to right,
    ${WIDGET_PREVIEW_TRAY_GRADIENT.start} 0%,
    ${WIDGET_PREVIEW_TRAY_GRADIENT.end} 100%
  );

  &:hover ${PreviewExpandButton} {
    opacity: 1;
    pointer-events: auto;
  }
`;

export const PreviewInnerCard = styled.div`
  flex: 0 1 auto;
  width: 65%;
  min-width: 0;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  margin-left: auto;
  margin-right: auto;
  border-radius: ${(props) => props.theme.borderRadius.base};
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

export const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) => props.theme.spacing.sm} ${(props) => props.theme.spacing.md};
  gap: ${(props) => props.theme.spacing.sm};
`;
